import { useStore } from './store';
import { TYPE_CONFIG } from './constants';
import { Plus, Search } from 'lucide-react';
import { useState } from 'react';

export const NodeLibrary = () => {
  const addNodeByType = useStore((s) => s.addNodeByType);
  const [search, setSearch] = useState('');

  const filteredNodes = Object.entries(TYPE_CONFIG).filter(
    ([type, config]) =>
      type !== 'webhook_result' &&
      (config.label.toLowerCase().includes(search.toLowerCase()) ||
      config.description.toLowerCase().includes(search.toLowerCase()))
  );

  return (
    <div className="w-full h-full flex flex-col overflow-hidden bg-white">
      <div className="p-6 border-b border-slate-100 space-y-4">
        <div>
          <h3 className="text-sm font-black text-slate-800 uppercase tracking-tighter">Node Library</h3>
          <p className="text-[10px] font-bold text-slate-400 uppercase tracking-widest mt-1">Add components to flow</p>
        </div>
        
        <div className="relative">
          <Search size={14} className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400" />
          <input 
            type="text" 
            placeholder="Search nodes..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            className="w-full pl-9 pr-4 py-2.5 bg-slate-50 border border-slate-100 rounded-xl text-xs font-bold text-slate-600 focus:outline-none focus:ring-4 focus:ring-indigo-50/50 focus:border-indigo-200 outline-none transition-all"
          />
        </div>
      </div>

      <div className="flex-1 overflow-y-auto p-4 space-y-3 custom-scrollbar">
        {filteredNodes.map(([type, config]) => {
          const Icon = config.icon;
          
          return (
            <button
              key={type}
              onClick={() => addNodeByType(type)}
              draggable={true}
              onDragStart={(event) => {
                event.dataTransfer.setData('application/reactflow', type);
                event.dataTransfer.effectAllowed = 'move';
              }}
              className="w-full flex items-start gap-4 p-4 rounded-2xl border border-slate-100 bg-white hover:border-indigo-200 hover:shadow-lg hover:shadow-indigo-50/20 transition-all group text-left cursor-grab active:cursor-grabbing"
            >
              <div className={`w-10 h-10 rounded-xl ${config.color} flex items-center justify-center shrink-0 group-hover:scale-110 transition-transform overflow-hidden`}>
                {typeof Icon === 'string' ? (
                  <img src={Icon} alt="" className="w-full h-full object-contain scale-125" />
                ) : (
                  <Icon size={20} />
                )}
              </div>
              <div className="overflow-hidden">
                <h4 className="text-xs font-black text-slate-700 uppercase tracking-tight mb-1 flex items-center gap-2">
                  {config.label}
                  <Plus size={10} className="text-slate-300 group-hover:text-indigo-500" />
                </h4>
                <p className="text-[10px] text-slate-400 font-medium leading-relaxed line-clamp-2">
                  {config.description}
                </p>
              </div>
            </button>
          );
        })}
      </div>
    </div>
  );
};
